var map = {
	"./01-ingen-fattigdom.png": 552,
	"./02-ingen-hunger.png": 9049,
	"./03-god-halsa-och-valbefinnande.png": 982,
	"./04_god_utbildning.png": 590,
	"./05-jamstalldhet.png": 4094,
	"./06-rent-vatten-och-sanitet-for-alla.png": 4071,
	"./07-hallbar-energi-for-alla.png": 4566,
	"./08-anstandiga-arbetsvillkor-och-ekonomisk-tillvaxt.png": 199,
	"./09-hallbar-industri-innovationer-och-infrastruktur.png": 2652,
	"./10-minskad-ojamnlikhet.png": 3594,
	"./11-hallbara-stader-och-samhallen.png": 7117,
	"./12-hallbar-konsumtion-och-produktion.png": 7588,
	"./13-bekampa-klimatforandringarna.png": 7795,
	"./14_hav_och_marina_resurser.png": 4250,
	"./15_ekosystem.png": 3545,
	"./16_fredliga_samhallen.png": 1823,
	"./17_genomforande_och_partnerskap.png": 1939,
	"./Game.jpeg": 9079,
	"./familjen.jpeg": 8889,
	"./horse.png": 6123,
	"./king.jpg": 5815,
	"./landing-page.jpeg": 6521,
	"./rida-min.jpeg": 5151,
	"./sound/fail.mp3": 720,
	"./sound/win.mp3": 9000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;